import { render } from "./BusinessHypothesisIcon.vue?vue&type=template&id=03628c80&scoped=true"
import script from "./BusinessHypothesisIcon.vue?vue&type=script&lang=js"
export * from "./BusinessHypothesisIcon.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-03628c80"

export default script